module.exports = __webpack_public_path__ + "static/quickswitcher-f91e1c275ef9632a03a6842e452f7bb0.png";